module.exports = __webpack_public_path__ + "media/icons/3@2x-9a86140f.png";